import { useMutation } from "@tanstack/react-query";
import { apiCrudBuilder, baseUrl } from "components/shared/apiCrudBuilder";
import { AuthenticationContext } from "components/context/AuthenticationProvider";
import { useContext } from "react";

const path = `${baseUrl}/contact`;

export const { useGet: useGetContact } = apiCrudBuilder(path, "Contact");

export const useAddToGoogle = (options) => {
  const { appAxios } = useContext(AuthenticationContext);

  return useMutation({
    ...options,
    mutationFn: (id) =>
      appAxios.post(`${path}/${id.replace("/", "__")}/add_to_google/`, {}),
  });
};
